import { React, useEffect } from "react";
import BoardPrototype from "../components/BoardPrototype";
import GameSettings from "../components/GameSettings";
import { useGlobalContext } from "../context";

const Play = () => {
  const { setFen } = useGlobalContext();
  useEffect(() => {
    setFen("rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1");
  }, [setFen]);
  return (
    <main>
      <div className="section">
        <BoardPrototype />
        <GameSettings />
      </div>
    </main>
  );
};

export default Play;
